











































































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import FileUpload from "vue-upload-component";
import { FileUploadCategoryModel, FileUploadErrorModel } from "@/shared/types";

const getExtension = (str: string) => str.lastIndexOf(".") > 0 ? str.trim().toLowerCase().slice(str.lastIndexOf(".")) : undefined;

@Component({
  components: {
    FileUpload
  }
})
export default class UploadForm extends Vue {
  @Prop({ required: true })
  category: FileUploadCategoryModel; // category

  @Prop( {required: false})
  serverErrors: FileUploadErrorModel[];


  files = [];
  uploadErrors = [];

  get allowedFileTypes () {
    return this.category.allowedFileTypes.map(t => t.trim().toLowerCase()).toString();
  }

  get allowedFileTypesForDisplay () {
    const space = " ";
    return this.category.allowedFileTypes.map(t => `${space}${t.trim().toLowerCase()}`).toString();
  }

  get maxFileSize () {
    return 1024 * 1024 * this.category.fileSize;
  }

  get maxUploadFilesReached () {
    return this.mappedFiles.length >= this.category.maxFiles;
  }

  get disableUpload () {
    return this.maxUploadFilesReached;
  }

  get mappedFiles () {
    // only take maximum allowed number of files
    // when multiple: true, a user can upload any number of files from the component at once.
    this.files = this.files.slice(0, this.category.maxFiles);
    return this.files;
  }

  get showServerValidationErrorMessage () {
    return this.hasServerErrors && this.uploadErrors.length > 0;
  }

  get hasServerErrors () {
    return this.serverErrors && this.serverErrors.length > 0;
  }

  mounted () {
    if (this.hasServerErrors) {
      this.serverErrors.forEach(error => {
        this.addError({ file: error.fileName, msg: error.message });
      });
    }
  }

  inputFilter (newFile, oldFile, prevent) {
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      const extension = getExtension(newFile.name);
      if (extension === undefined || extension === "" || !this.allowedFileTypes.includes(extension)) {
        this.addError({ file: newFile.name, msg: "file type not allowed" });
        return prevent();
      }

      if (newFile.size > this.maxFileSize) {
        this.addError({ file: newFile.name, msg: `file must be smaller than ${this.category.fileSize} MB`});
        return prevent();
      }
    }
  }

  addError (error) {
    if (!this.uploadErrors.includes(error)) {
      this.uploadErrors.push(error);
    }
  }

  updateFiles () {
    const mappedFiles = this.mappedFiles.map(f => f.file);
    this.$emit("onFiles", mappedFiles);
    if (this.maxUploadFilesReached) {
      this.clearErrors();
    }
  }

  deleteFile (file) {
    const uploadComponent: any = this.$refs.upload;
    uploadComponent.remove(file);
  }

  deleteError (error) {
    this.uploadErrors = this.uploadErrors.filter(x => x !== error);
  }

  clearErrors () {
    this.uploadErrors = [];
  }
}
